import { Field } from "../classes/AutoEncoder";
export function field(settings) {
    return (target /* future typeof Model */, key) => {
        var _a, _b, _c, _d, _e, _f;
        if (!target.constructor.fields) {
            target.constructor.fields = [];
            target.constructor.fields.createdFor = target.constructor;
        }
        else {
            if (target.constructor.fields.createdFor && target.constructor.fields.createdFor !== target.constructor) {
                // need to clone instead of creating a new reference
                target.constructor.fields = target.constructor.fields.slice(0);
                target.constructor.fields.createdFor = target.constructor;
                target.constructor.cachedPatchType = undefined;
            }
        }
        const field = new Field();
        field.optional = (_a = settings.optional) !== null && _a !== void 0 ? _a : false;
        field.nullable = (_b = settings.nullable) !== null && _b !== void 0 ? _b : false;
        field.decoder = settings.decoder;
        field.version = (_c = settings.version) !== null && _c !== void 0 ? _c : 0;
        field.field = (_d = settings.field) !== null && _d !== void 0 ? _d : key;
        field.upgrade = settings.upgrade;
        field.downgrade = settings.downgrade;
        field.upgradePatch = settings.upgradePatch;
        field.downgradePatch = settings.downgradePatch;
        field.defaultValue = settings.defaultValue;
        field.patchDefaultValue = settings.patchDefaultValue;
        field.property = key;
        target.constructor.fields.push(field);
        target.constructor.latestVersion = Math.max((_e = target.constructor.latestVersion) !== null && _e !== void 0 ? _e : 0, (_f = settings.version) !== null && _f !== void 0 ? _f : 0);
        target.constructor.sortFields();
    };
}
//# sourceMappingURL=Field.js.map